'use strict';

var ArrowForward = require('../../../_virtual/ArrowForward.js_commonjs-exports.js');
var interopRequireDefault = require('../../@babel/runtime/helpers/interopRequireDefault.js');
var React = require('react');
require('./utils/createSvgIcon.js');
var createSvgIcon = require('../../../_virtual/createSvgIcon.js_commonjs-exports.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _interopRequireDefault = interopRequireDefault;

Object.defineProperty(ArrowForward.__exports, "__esModule", {
  value: true
});
exports["default"] = ArrowForward.__exports.default = void 0;

var _react = _interopRequireDefault(React__default["default"]);

var _createSvgIcon = _interopRequireDefault(createSvgIcon.__exports);

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
}), 'ArrowForward');

exports["default"] = ArrowForward.__exports.default = _default;

module.exports = exports["default"];
